<template>
	<form class="add-search-default-text" @submit.prevent="saving">
		<managing-section>
			<managing-box title="분류">
				<RadioList
					v-if="!idSearchRecommend || activeDeleteBtn"
					v-model="recommendType"
					:radio-list="recommendTypeList"
				/>
				<template v-else>{{
					searchRecommendData && searchRecommendData.recommendType
				}}</template>
			</managing-box>
			<managing-box title="시작/마감">
				<DateRange v-model="datePeriod" ref="datePeriod" />
			</managing-box>
			<managing-box title="활성여부">
				<RadioList
					v-if="!idSearchRecommend || activeDeleteBtn"
					v-model="isDisplay"
					:radio-list="isDisplayList"
				/>
				<template v-else>{{
					searchRecommendData
						? isDisplayList.find(
								item =>
									item.id === searchRecommendData.isDisplay
							).value
						: ''
				}}</template>
			</managing-box>
			<managing-box title="검색어">
				<input
					ref="recommendText"
					type="text"
					v-model="recommendText"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button type="submit" class="btn-main blue" v-text="'저장하기'" />
			<button
				type="button"
				class="btn-main"
				v-text="'다시작성'"
				@click="rewrite"
			/>
			<button
				v-if="activeDeleteBtn"
				type="button"
				class="btn-main red"
				v-text="'삭제하기'"
				@click="deleting"
			/>
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'목록으로'"
				@click="toList"
			/>
		</div>
	</form>
</template>

<script>
	import moment from 'moment';
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import DateRange from '@/components/DateRange';

	export default {
		name: 'AddSearchDefaultText',
		components: { ManagingSection, ManagingBox, RadioList, DateRange },
		data() {
			return {
				idSearchRecommend: null,
				searchRecommendData: null,
				recommendTypeList: [],
				recommendType: '',
				datePeriod: { from: '', to: '' },
				isDisplayList: [
					{ id: true, value: '활성' },
					{ id: false, value: '비활성' },
				],
				isDisplay: true,
				recommendText: '',
			};
		},
		computed: {
			...mapState({
				idRegister: state => state.login.idRegister,
			}),
			activeDeleteBtn() {
				const data = this.searchRecommendData;
				return (
					data &&
					data.recommendType !== 'main_placeholder' &&
					data.recommendType !== 'review_placeholder' &&
					data.recommendType !== 'common_placeholder'
				);
			},
		},
		created() {
			this.idSearchRecommend = this.$route.query.idSearchRecommend;
		},
		async mounted() {
			await this.getCategory();
			if (this.idSearchRecommend) await this.getData();
		},
		methods: {
			async getCategory() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/operation/searchRecommends/category'
					);
					this.recommendTypeList = Object.keys(data).map(
						(key, idx) => {
							if (idx === 0) this.recommendType = key;
							return { id: key, value: data[key] };
						}
					);
				} catch (err) {
					console.error(err);
					alert(
						'카테고리를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			setData() {
				const data = this.searchRecommendData;
				this.recommendType = data.recommendType;
				this.datePeriod = {
					from: moment(data.startDate, 'YYYYMMDDHHmmss').format(
						'YYYY-MM-DDTHH:mm'
					),
					to: moment(data.endDate, 'YYYYMMDDHHmmss').format(
						'YYYY-MM-DDTHH:mm'
					),
				};
				this.isDisplay = data.isDisplay;
				this.recommendText = data.recommendText;
			},
			rewrite() {
				if (this.searchRecommendData) {
					this.setData();
				} else {
					this.recommendType = this.recommendTypeList[0].id;
					this.datePeriod = { from: '', to: '' };
					this.isDisplay = true;
					this.recommendText = '';
				}
			},
			toList() {
				this.$router.go(-1);
			},
			getParams() {
				const { from, to } = this.datePeriod;
				const recommendText = this.recommendText;
				const returnFalseAlert = msg => {
					alert(msg);
					return false;
				};
				if (!from) {
					this.$refs.datePeriod.focus();
					return returnFalseAlert('시작 일시를 지정하세요');
				} else if (!to) {
					this.$refs.datePeriod.focus('to');
					return returnFalseAlert('종료 일시를 지정하세요');
				} else if (!recommendText) {
					this.$refs.recommendText.focus();
					return returnFalseAlert('검색어를 입력하세요');
				}
				return {
					idRegister: this.idRegister,
					recommendType: this.recommendType,
					startDate: moment(from, 'YYYY-MM-DDTHH:mm').format(
						'YYYYMMDDHHmmss'
					),
					endDate: moment(to, 'YYYY-MM-DDTHH:mm').format(
						'YYYYMMDDHHmmss'
					),
					isDisplay: this.isDisplay,
					recommendText,
				};
			},
			async saving() {
				try {
					const params = this.getParams();
					if (!params) return;
					if (this.searchRecommendData) {
						await this.$axiosAdmin2.put(
							`/api/operation/searchRecommends/${this.idSearchRecommend}`,
							params
						);
					} else {
						await this.$axiosAdmin2.post(
							'/api/operation/searchRecommends',
							params
						);
					}
					alert('정상처리 되었습니다.');
					this.toList();
				} catch (err) {
					console.error(err);
					alert(
						'검색기본텍스트를 저장하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async deleting() {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					const { data } = await this.$axiosAdmin2.delete(
						`/api/operation/searchRecommends/${this.idSearchRecommend}`
					);
					if (data.result) {
						alert('정상처리 되었습니다.');
						this.toList();
					} else {
						throw '실패';
					}
				} catch (err) {
					console.error(err);
					alert('삭제하는데 실패했습니다. 개발팀에 문의하세요.');
				}
			},
			async getData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/searchRecommends/${this.idSearchRecommend}`
					);
					this.searchRecommendData = data;
					this.setData();
				} catch (err) {
					console.error(err);
					alert(
						'데이터를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
